import { IAppState } from 'src/app/redux/store/reducers';
import IConfig from 'src/app/data/config/interfaces/IConfig';

export const getConfig = (state: IAppState): IConfig | null => state.config.data.item;
